import { type SelectProps } from 'antd';
import { type RuleType, type Field } from 'react-querybuilder';
import { DataSource } from '../../utils';

export enum InputType {
  Input = 'Input',
  Select = 'Select',
  SearchSelect = 'SearchSelect',
  SearchInput = 'SearchInput',
}

export type QueryBuilderRule = Omit<RuleType, 'value'> & {
  key?: null | string;
  value: {
    value: any;
    label: string;
  }[];
  display?: string;
}

export interface QueryBuilderGroupRule {
  combinator: string;
  rules: QueryBuilderRule[];
}
export interface Query {
  combinator: string;
  rules: (QueryBuilderRule | QueryBuilderGroupRule)[];
}

export type QueryBuilderFieldSchema = Field & {
  category: string;
  inputType: InputType;
  autoCompletion: boolean;
  operatorOptions: { label: string; value: string; }[];
  valueOptions: { label: string; value: string | number; }[];
  getValueOptions?: (pattern: string) => Promise<{label: string; value: string;}[]>;
  getTagKeyOptions?: (pattern: string) => Promise<{label: string; value: string;}[]>,
  getTagValueOptions?: (pattern: string, key: string) => Promise<{label: string; value: string;}[]>;
}

export interface QueryBuilderContext {
  dataSource: DataSource;
  showError: boolean;
  initialField: QueryBuilderFieldSchema;
  fields: QueryBuilderFieldSchema[];
  groupedFields: SelectProps['options'];
  addRule: (ruleOrGroup: QueryBuilderRule | QueryBuilderGroupRule, parentPath?: number[]) => void;
  onFieldChange: (field: string, path: number[], schema: QueryBuilderFieldSchema) => void;
  onKeyChange: (key: string | null, path: number[], schema: QueryBuilderFieldSchema) => void;
  onValueChange: (data: { value: string | number; label: string; }[], path: number[], schema: QueryBuilderFieldSchema) => void;
  onOperatorChange: (operator: string, path: number[], schema: QueryBuilderFieldSchema) => void;
}

export interface BaseSelectorProps {
  context: QueryBuilderContext;
  schema: {
    fields: QueryBuilderFieldSchema[];
  }
}